import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ConfirmModal from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.confirmModal,
  };
}

export default withRouter(connect(mapStateToProps)(ConfirmModal));



// WEBPACK FOOTER //
// ./src/components/ConfirmModal/container/index.js